export interface Category {
  id: number;
  name: string;
  nameEn: string;
  url: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    id: 911,
    name: 'Chaussures',
    nameEn: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20white%20leather%20designer%20sneakers%20positioned%20on%20a%20minimalist%20concrete%20surface%20with%20soft%20morning%20window%20light%20casting%20gentle%20shadows%2C%20clean%20editorial%20product%20photography%2C%20cream%20and%20warm%20gray%20background%2C%20luxury%20minimal%20aesthetic%2C%20single%20item%20focus%20with%20no%20distractions&width=600&height=600&seq=uniq-cat-sneakers-v2&orientation=squarish',
  },
  {
    id: 912,
    name: 'Hoodies / Sweaters',
    nameEn: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Oversized%20beige%20cashmere%20hoodie%20draped%20artfully%20over%20a%20wooden%20chair%20in%20a%20sunlit%20Scandinavian%20room%2C%20natural%20texture%20details%20visible%2C%20soft%20diffused%20afternoon%20light%2C%20hygge%20atmosphere%2C%20minimalist%20interior%20with%20potted%20plant%2C%20editorial%20lifestyle%20photography&width=600&height=600&seq=uniq-cat-oversized-hoodie&orientation=squarish',
  },
  {
    id: 913,
    name: 'T-Shirts',
    nameEn: 'T-Shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20organic%20cotton%20white%20t-shirt%20neatly%20folded%20on%20a%20rustic%20linen%20fabric%20surface%2C%20soft%20golden%20hour%20sunlight%20streaming%20from%20the%20side%2C%20delicate%20fabric%20texture%20details%2C%20warm%20earthy%20tones%20with%20terracotta%20accents%2C%20artisan%20craftsmanship%20vibe%2C%20clean%20minimal%20product%20shot&width=600&height=600&seq=uniq-cat-organic-tee&orientation=squarish',
  },
  {
    id: 914,
    name: 'Vestes',
    nameEn: 'Jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tailored%20camel%20wool%20blazer%20hanging%20elegantly%20on%20a%20minimalist%20brass%20wall%20hook%20against%20a%20warm%20sand-colored%20plaster%20wall%2C%20soft%20directional%20light%20creating%20subtle%20fabric%20highlights%2C%20Italian%20craftsmanship%20aesthetic%2C%20luxury%20boutique%20atmosphere%2C%20refined%20editorial%20style&width=600&height=600&seq=uniq-cat-tailored-blazer&orientation=squarish',
  },
  {
    id: 915,
    name: 'Pantalons / Shorts',
    nameEn: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Well-tailored%20cream%20linen%20trousers%20laid%20flat%20on%20a%20light%20oak%20parquet%20floor%2C%20natural%20sunlight%20from%20a%20tall%20window%20creating%20striped%20shadow%20patterns%2C%20Mediterranean%20summer%20vibe%2C%20crisp%20fabric%20texture%20visible%2C%20clean%20architectural%20composition%2C%20editorial%20fashion%20photography&width=600&height=600&seq=uniq-cat-tailored-pants&orientation=squarish',
  },
  {
    id: 916,
    name: 'Couvre-chefs',
    nameEn: 'Headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20wide-brim%20straw%20fedora%20hat%20resting%20on%20a%20weathered%20white%20wooden%20stool%20outdoors%2C%20golden%20late%20afternoon%20sun%20backlighting%20the%20brim%2C%20soft%20bokeh%20garden%20background%20with%20lavender%20hints%2C%20Provencal%20summer%20aesthetic%2C%20warm%20nostalgic%20atmosphere%2C%20editorial%20travel%20photography&width=600&height=600&seq=uniq-cat-straw-fedora&orientation=squarish',
  },
  {
    id: 917,
    name: 'Ensembles',
    nameEn: 'Sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20sage%20green%20linen%20two-piece%20set%20displayed%20on%20a%20minimalist%20wooden%20mannequin%20against%20a%20warm%20terracotta%20toned%20wall%2C%20soft%20gallery%20lighting%20from%20above%2C%20botanical%20styling%20with%20dried%20grasses%2C%20contemporary%20art%20gallery%20vibe%2C%20sophisticated%20editorial%20composition&width=600&height=600&seq=uniq-cat-coord-set&orientation=squarish',
  },
  {
    id: 918,
    name: 'Sous-vêtements',
    nameEn: 'underwear/underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxurious%20champagne%20silk%20underwear%20set%20delicately%20placed%20on%20a%20soft%20cashmere%20throw%20blanket%2C%20candlelit%20warm%20ambient%20glow%2C%20intimate%20boudoir%20atmosphere%2C%20soft%20focus%20edges%2C%20pearl%20and%20cream%20color%20palette%2C%20elegant%20sensual%20photography%2C%20premium%20lingerie%20editorial&width=600&height=600&seq=uniq-cat-silk-underwear&orientation=squarish',
  },
  {
    id: 919,
    name: 'Maillots',
    nameEn: 'Jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20athletic%20jersey%20in%20deep%20forest%20green%20with%20white%20stripes%20displayed%20on%20a%20dark%20matte%20hanger%20against%20a%20clean%20gym%20locker%20room%20wall%2C%20dramatic%20spotlight%20effect%2C%20moisture-wicking%20fabric%20texture%20visible%2C%20sporty%20yet%20premium%20aesthetic%2C%20dynamic%20composition%2C%20athletic%20brand%20photography&width=600&height=600&seq=uniq-cat-sports-jersey&orientation=squarish',
  },
  {
    id: 920,
    name: 'Accessoires',
    nameEn: 'Accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Delicate%20gold%20layered%20necklaces%20and%20a%20minimalist%20watch%20arranged%20on%20a%20smooth%20marble%20surface%20with%20soft%20reflections%2C%20diffused%20studio%20lighting%20from%20multiple%20angles%2C%20luxury%20jewelry%20boutique%20aesthetic%2C%20warm%20champagne%20and%20ivory%20tones%2C%20high-end%20catalog%20photography&width=600&height=600&seq=uniq-cat-gold-jewelry&orientation=squarish',
  },
  {
    id: 921,
    name: 'Sacs',
    nameEn: 'Bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Structured%20cognac%20leather%20tote%20bag%20standing%20on%20a%20minimalist%20white%20display%20pedestal%2C%20dramatic%20side%20lighting%20creating%20rich%20leather%20texture%20highlights%2C%20gallery-style%20presentation%20with%20clean%20white%20walls%2C%20Italian%20artisan%20workshop%20atmosphere%2C%20premium%20handbag%20editorial%2C%20sharp%20shadows&width=600&height=600&seq=uniq-cat-leather-tote&orientation=squarish',
  },
  {
    id: 922,
    name: 'Ceintures',
    nameEn: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Handcrafted%20braided%20tan%20leather%20belt%20coiled%20elegantly%20on%20a%20dark%20walnut%20wooden%20surface%2C%20warm%20directional%20desk%20lamp%20lighting%2C%20artisan%20workshop%20tools%20subtly%20visible%20in%20background%20bokeh%2C%20rich%20cognac%20and%20mahogany%20tones%2C%20traditional%20craftsmanship%20aesthetic%2C%20product%20detail%20photography&width=600&height=600&seq=uniq-cat-braided-belt&orientation=squarish',
  },
  {
    id: 923,
    name: 'Parfums',
    nameEn: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artisanal%20niche%20perfume%20bottle%20with%20dark%20amber%20glass%20and%20minimalist%20label%20on%20a%20black%20slate%20surface%2C%20dramatic%20chiaroscuro%20lighting%20with%20single%20spotlight%2C%20fragrance%20mist%20subtly%20visible%2C%20luxury%20parfumerie%20atmosphere%2C%20mysterious%20and%20sophisticated%20mood%2C%20high-contrast%20editorial&width=600&height=600&seq=uniq-cat-niche-perfume&orientation=squarish',
  },
  {
    id: 924,
    name: 'Autres articles',
    nameEn: 'OtherStuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20tortoiseshell%20sunglasses%20with%20gold%20accents%20resting%20on%20a%20stack%20of%20art%20books%20near%20a%20sunlit%20window%2C%20soft%20natural%20morning%20light%20with%20gentle%20lens%20reflections%2C%20cozy%20reading%20nook%20atmosphere%2C%20intellectual%20elegance%2C%20warm%20cream%20and%20honey%20tones%2C%20lifestyle%20editorial%20photography&width=600&height=600&seq=uniq-cat-sunglasses&orientation=squarish',
  },
];